import React from 'react';
import { useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import BootNav from './Components/BootNav/BootNav';
import './custom.scss';

export function Layout({ 
  notifications, 
  addNotification, 
  removeNotification, 
  markAsRead, 
  setNotifications,
  clearAllNotifications 
}) {
  let user = sessionStorage.getItem('user')
  const navigate = useNavigate()
  
  useEffect(() => {
    if (!user) {
      navigate('/')
    }
  }, [user])

  return (
    <div>
      <BootNav
        notifications={notifications}
        addNotification={addNotification}
        onRemoveNotification={removeNotification}
        onMarkAsRead={markAsRead}
        setNotifications={setNotifications}
        clearAllNotifications={clearAllNotifications}
      />
      <div>
        <Outlet />
      </div>
    </div>
  );
};